import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getIsInDetachMode } from "src/duck/selectors";
import { withFrame } from "src/components/Frame/Context";

function FullScreen({
  position = "static",
  children,
  frame,
  zIndex = "auto",
  ignoreFrame = false,
  bg = "surface",
  ...rest
}) {
  const isInDetachMode = useSelector(getIsInDetachMode);

  const framePxHeigt = (frame ? frame.height : 0) + "px";
  const isAbsolute = position === "absolute";
  const isFixed = position === "fixed";

  let top = "0px";
  let height = `calc(100vh - ${isInDetachMode ? "0px" : framePxHeigt})`;

  if (ignoreFrame) {
    height = "100vh";
  } else if (isAbsolute || isFixed) {
    top = framePxHeigt;
  }
  return (
    <Box
      bg={bg}
      width="100vw"
      zIndex={zIndex}
      overflow="hidden"
      top={top}
      left="0px"
      height={height}
      pos={position}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default withFrame(FullScreen);
